module.exports = __webpack_public_path__ + "img/edit.fd66fdcb.svg";